module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/portofolio-tst.json
// module id = 854
// module chunks = 221507175971759